<div
  [class]="'app-header header-shadow' + ((config$ | async)?.headerTheme || '')"
>
  <div class="logo-src"></div>
  <div class="app-header__content">
    <div class="app-header-left">
      <img
        src="./assets/images/logo-inverse.png"
        style="cursor: pointer"
        alt=""
        (click)="gotodashboard()"
      />
    </div>
    <div class="app-header-right">
      <div
        style="
          background-color: white;
          color: red;
          margin-right: 30px;
          padding: 4px 12px;
          border-radius: 25px;
        "
        *ngIf="data && data.message"
      >
        <p
          *ngIf="data.message || data.date"
          style="margin-bottom: 0; display: flex; align-items: center"
        >
          <strong *ngIf="data.message">{{ data.message }}&nbsp;</strong>
          <strong *ngIf="data.date">{{
            data.date | date : "dd MMM yyyy"
          }}</strong>
        </p>
      </div>
      <app-dots></app-dots>
      <app-user-box *ngIf="!signin"></app-user-box>
      <app-user-box-login *ngIf="signin"></app-user-box-login>
    </div>
  </div>
  <div class="app-header__mobile-menu"></div>
  <div class="app-header__menu">
    <span>
      <button
        class="btn-icon btn-icon-only btn btn-primary"
        [ngClass]="{ 'is-active': globals.toggleHeaderMobile }"
        (click)="toggleHeaderMobile()"
      >
        <div class="btn-icon-wrapper">
          <fa-icon [icon]="['fas', 'ellipsis-v']"></fa-icon>
        </div>
      </button>
    </span>
  </div>
</div>
